/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { useState } from 'react';
import Helmet from '../../../commonComponents/Helmet';
import Tile from '../../common/Tile';
import PublicAutoLogoutLayout from './common/PublicLayout';
import {
	publicClientBasicInfoPageUrl,
	publicClientEntitiesPageUrl,
	publicClientInterestsPageUrl
} from '../../../core/constants';
import PublicFamilyMembersGrid from './familyMember/PublicFamilyMembersGrid';
import PublicPageSteps from './common/PublicPageSteps';
import { useProgress, useRequireProgress } from './common/PublicProgressContext';
import {
	ctxTermsAccepted,
	ctxClientTypeSelected,
	ctxClientBasicInfoCompleted,
	individualClientType
} from './common/publicConstants';
import { useNavigateWithAppName } from '../../common/NavigateWithAppName';

const PublicFamilyMembersPage = () => {
	const navigate = useNavigateWithAppName();
	const { clientTypeSelected } = useProgress();
	const [currentStep] = useState<number>(2);

	// Ensure the user has accepted the terms, selected a client type to access this page.
	useRequireProgress([ctxTermsAccepted, ctxClientTypeSelected, ctxClientBasicInfoCompleted]);

	const handleBackButtonClick = () => {
		navigate(publicClientBasicInfoPageUrl);
	};

	const handleContinueButtonClick = () => {
		if (clientTypeSelected === individualClientType) {
			navigate(publicClientInterestsPageUrl);
		} else {
			navigate(publicClientEntitiesPageUrl);
		}
	};

	return (
		<PublicAutoLogoutLayout>
			<Helmet>
				<title>Join Kelly+Partners | Prospective Client</title>
			</Helmet>
			<Tile>
				<PublicPageSteps currentStep={currentStep} />
				<PublicFamilyMembersGrid
					onBackButtonClick={handleBackButtonClick}
					onContinueButtonClick={handleContinueButtonClick}
				/>
			</Tile>
		</PublicAutoLogoutLayout>
	);
};

export default PublicFamilyMembersPage;
